import { render, staticRenderFns } from "./work-collect.vue?vue&type=template&id=4c48e017&scoped=true"
import script from "./work-collect.vue?vue&type=script&lang=js"
export * from "./work-collect.vue?vue&type=script&lang=js"
import style0 from "./work-collect.vue?vue&type=style&index=0&id=4c48e017&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48e017",
  null
  
)

export default component.exports